import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import { B as BoxStyled } from './Box.styles-YJrOTV3q.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';

const Box = ({
  children,
  flex,
  basis,
  grow,
  shrink,
  renderAs,
  paddingBlockStart,
  paddingBlockEnd,
  paddingInlineStart,
  paddingInlineEnd,
  bgColor,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('box')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(BoxStyled, _extends({}, getDataTaktAttributes(), rest, {
  $bgColor: bgColor,
  as: renderAs !== null && renderAs !== void 0 ? renderAs : 'div',
  $flex: flex,
  $basis: basis,
  $grow: grow,
  $shrink: shrink,
  $paddingBlockStart: paddingBlockStart,
  $paddingBlockEnd: paddingBlockEnd,
  $paddingInlineStart: paddingInlineStart,
  $paddingInlineEnd: paddingInlineEnd
}), children));
Box.propTypes = {
  /**
  * This is the content that will be shown in the Box
  */
  children: PT.node.isRequired,
  /**
  * Set the HTML element that the Box component should be render as
  */
  renderAs: PT.elementType,
  /**
  * Set logical block start padding (top padding) for Box body
  */
  paddingBlockStart: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
  * Set logical block end padding (bottom padding) for Box body
  */
  paddingBlockEnd: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
  * Set logical inline start padding (left padding) for Box body
  */
  paddingInlineStart: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
  * Set logical inline end padding (right padding) for Box body
  */
  paddingInlineEnd: PT.oneOf(['none', 'micro', 'mini', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge']),
  /**
   * Background color
   */
  bgColor: PT.oneOf(['default', 'offset'])
};
Box.defaultProps = {
  renderAs: 'div',
  paddingBlockStart: 'large',
  paddingBlockEnd: 'large',
  paddingInlineStart: 'large',
  paddingInlineEnd: 'large',
  bgColor: undefined
};

export { Box as B };
//# sourceMappingURL=Box-KawT9QR0.js.map
